<template>
<div class="panel mtpage ">


	<maincontent>
		<template v-slot:content>

            <div class="wallpapers">
                <div class="images images2">
                    <bgimage v-key="wp" v-for="wp in secondrow" :src="wp"/>
                </div>
                <div class="images images1">
                    <bgimage v-key="wp" v-for="wp in firstrow" :src="wp"/>
                </div>

                <div class="caption">
                    <logotype :big="true"/>
                </div>
            </div>

            <div class="calltoactionslide slide">
                <div class="caption">
                    <span>{{$t('landings.maincall')}}</span>
                </div>
                <div class="calltoaction">
                    <button class="button orange big" @click="gotosignin">{{$t('landings.tryfree')}}</button>
                </div>
            </div>

            <div class="feautures slide">
                <div class="feauture" :class="f.id" v-for="f in features">
                    <bgimage :src="f.bg">
                        <template v-slot:cnt>
                            <div class="feauturetexts">
                                <div class="subcaption"><span>{{$t('landings.features.caption.' + f.id)}}</span></div>
                                <div class="text"><span>{{$t('landings.features.text.' + f.id)}}</span></div>
                            </div>
                        </template>
                    </bgimage>
                    
                </div>
            </div>

            <div class="feautures big slide">
                <div class="feauture" :class="f.id" v-for="f in featuresbig">
                    <bgimage :src="f.bg">
                        <template v-slot:cnt>
                            <div class="feauturetexts">
                                <div class="subcaption"><span>{{$t('landings.features.caption.' + f.id)}}</span></div>
                                <div class="text"><span>{{$t('landings.features.text.' + f.id)}}</span></div>
                            </div>
                        </template>
                    </bgimage>
                    
                </div>
            </div>

            <div class="calltoactionslide slide">
                <div class="caption">
                    <span>{{$t('landings.smaincall')}}</span>
                </div>
                <div class="calltoaction">
                    <button class="button orange big" @click="gotosignin">{{$t('landings.tryfree')}}</button>
                </div>
            </div>

            <div class="storyWrapper">
                <withpreview ref="story" :nocontrols="true" :id="'bd7b551b-6151-cccc-9333-38edfc08c8e8'"/>
            </div>

            <div class="brandWrapper">
                <logotype :big="true"/>
            </div>

            <div class="mwork">
                <div class="footerWrapper">
                    <footerComponent />
                </div>
            </div>

		</template>
	</maincontent>


</div>
</template>

<style lang="sass" scoped>

.storyWrapper
    position: relative
    max-height: 100dvh
    aspect-ratio: 9 / 16
    margin : 2 * $r auto
    border-radius: 26px
    overflow: hidden

@supports not (height: 100dvh)
    .storyWrapper
        min-height: 100dvh

.slide
    padding : 4 * $r

    .caption
        max-width: 500px
        span
            font-size: 1.5em
            font-weight: 700

.feautures
    display: grid
    grid-template-columns: 1fr 1fr
    max-width: 800px
    margin : 0 auto
    grid-gap: 2 * $r
    margin-top: 4 * $r
    padding-bottom: 2 * $r

    .feauture
        .text
            margin-top: 2 * $r
            opacity: 1
            color : srgba(--color-shadow-var, 0.8)
            span
                font-size: 1em
                font-weight: 700

        .subcaption
            opacity: 1
            span
                font-size: 1.5em
                font-weight: 700
        .bgimage
            padding : 4 * $r
            aspect-ratio: 12 / 16
            border-radius: 26px

        .feauturetexts
            height: 100%
            display: flex
            flex-flow: column

        &.f2
            .feauturetexts
                .subcaption,
                .text
                    color : #fff
                    text-shadow: 0px 0px 2px srgba(--color-shadow-base, 0.914), 0 0 3px srgba(--color-shadow-base, 0.819)

    &.big
        margin-top: 0
        padding-top: 0
        grid-template-columns: 1fr

        .text
            max-width: 350px
             color : srgba(--color-shadow-var, 1)

        .bgimage
            aspect-ratio: 16 / 9!important



.mwork
    max-width: 700px
    margin: 0 auto

.calltoactionslide
    width: 100%
    min-height: 33vh
    overflow: hidden
    position: relative
    justify-content: center
    align-items: center
    display: flex
    padding-top: 6 * $r
    text-align: center
    flex-flow: column

    .calltoaction
        margin-top: 6 * $r
        text-align: center

.wallpapers
    width: 100%
    height: 66vh
    background: srgb(--color-shadow-base)
    overflow: hidden
    position: relative
    box-shadow: inset 0px 0px 20vh rgba(0,0,0,1)

    .caption
        position: absolute
        left: 0
        right: 0
        display: flex
        top : 33%
        justify-content: center
        align-items: center
        z-index: 3

        ::v-deep
            img
                width: 120px
                height: auto
    

    .images
        display: flex
        justify-content: center
        align-items: center
        flex-wrap: nowrap
        position: absolute
        flex-flow: row-reverse
        bottom : 0
        left : 45%
        gap : $r
        margin-left: -50vw
        min-width: 100vw
        z-index: 2

    .bgimage
        width: 150px
        aspect-ratio: 1
        border-radius: 26px
        box-shadow: inset 0px 0px 3vh rgba(0,0,0,0.8)
        margin-bottom: -3 * $r

    .images1
        +shadowSmall()


    .images2
        z-index: 1
        bottom : 80px
        opacity: 0.8

        .bgimage
            
            width: 140px
            filter: blur(1px)

.brandWrapper
    display: flex
    align-items: center
    justify-content: center
    height: 33vh

@media only screen and (max-width: 768px)
    .storyWrapper
        margin-left: $r
        margin-right: $r
    .wallpapers
        height: 55vh

        .bgimage
            width: 140px
            border-radius: 26px

        .images1
            +shadowSmall()
            left: 30%


        .images2
            left: 30%

            bottom : 130px

            .bgimage
                border-radius: 12px
                width: 90px

    .feautures
        grid-template-columns: 1fr

        .feauture

            .bgimage
                padding : 2 * $r
                aspect-ratio: 9 / 16
                
            .text
                span
                    font-size: 1.3em

            .subcaption
                span
                    font-size: 2em

        &.big

            .text

            .bgimage
                aspect-ratio: 9 / 16!important

</style>

<script>

import { mapState } from 'vuex';
import story from "@/components/modules/stories/story/index.vue";
import withpreview from "@/components/modules/stories/withpreview/index.vue";


var c = 12
export default {
	name: 'landing_main_page',
	components: {
        story,
        withpreview
	},

	data : function(){
        console.log(this.core.api.server)
		return { 
			searchEnabled : false,
            locales : {en : true, ru : true},
            wallpapers : [],
            features : [
                {
                    id : 'f1',
                    bg : this.core.api.server + '/downloads/static/f3.jpg'
                },{
                    id : 'f2',
                    bg : this.core.api.server + '/downloads/static/f4.jpg'
                },{
                    id : 'f3',
                    bg : this.core.api.server + '/downloads/static/f2.jpg'
                },{
                    id : 'f4',
                    bg : this.core.api.server + '/downloads/static/f1.jpg'
                }
            ],
            featuresbig : [{
                    id : 'f5',
                    bg : this.core.api.server + '/downloads/static/f5.jpg'
                }
            ]
		}
	},

	computed: mapState({
        locale : function(state){
            return this.locales[state.locale] ? state.locale : 'en'
        },

        firstrow : function(){
            return _.first(this.wallpapers, c)
        },

        secondrow : function(){
            return this.wallpapers.slice(c);
        },
	}),

	methods: {
		gotosignin : function(){
            this.$router.push('/signin').catch(e => {})
        },

        load : function(){
            this.core.api.app.wallpapers().then((files) => {
                this.wallpapers = files
            })
        }
	},

	mounted() {
        this.load()
	}
}
</script>
